import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-void text-text-primary flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="max-w-md w-full text-center"
        data-testid="subscription-success-container"
      >
        <CheckCircle className="w-20 h-20 text-gold mx-auto mb-6" />
        <h1 className="font-playfair text-3xl font-bold mb-4">
          Welcome to the Journey!
        </h1>
        <p className="text-text-secondary mb-8">
          Your subscription is active. You'll receive monthly insights and personalized guidance via email.
        </p>
        <Button
          onClick={() => navigate('/')}
          className="bg-gold text-void hover:bg-gold-hover rounded-full px-8 py-3 font-medium transition-all"
          data-testid="return-home-subscription-button"
        >
          Return Home
        </Button>
      </motion.div>
    </div>
  );
};

export default SubscriptionSuccess;
